import "../../css/bootstrap.min.css";
import "../../css/main.css";
import "../../css/guest.css";

import { strReplace, isPhone, encryptByDES, httpHeader } from "../public.js";
import { logoImg } from "../img.js";
import { loadDialog } from "../Modal.js";

//自訂介面view
import view from "../Modal.js";

$(function () {
  $("#dialogModal").html(loadDialog);
  $("#logoImg").html(logoImg);

  let url = location.href;
  let query = url.indexOf("?") === -1 ? null : url.split("?").slice(-1)[0];
  if (query !== null) {
    if (query.split("=")[0] === "lane") {
      let lane = query.split("=")[1];
      view.loadingShow();
      setTimeout(() => {
        $.ajax({
          type: "GET",
          url: `../api/guestForm.php?${new Date().getTime()}&lane=${lane}`,
          dataType: "json",
          headers: httpHeader(),
          success: function (json) {
            let data = json.result;
            $("#carplate").val(data.plate);
            view.loadingHide();
            // $("#userName").val(data.name);
            // $("#userPhone").val(data.phone);
            // if(data.rmk !== "SYS"){
            //     $("#Place").val(data.rmk);
            // }
          },
          error: function (error) {
            console.log(error);
            view.messageShow("錯誤", JSON.stringify(error));
            return;
          },
        });
      }, 1000);

      // 刷新車號
      // setInterval(() => {
      //   let beforePlate = $("#carplate").val();
      //   $.ajax({
      //     type: "GET",
      //     url: `../api/guestForm.php?${new Date().getTime()}&lane=${lane}`,
      //     dataType: "json",
      //     headers: httpHeader(),
      //     success: function (json) {
      //       let data = json.result;
      //       if (beforePlate !== data.plate) {
      //         view.loadingShow();
      //         setTimeout(() => {
      //           $("#carplate").val(data.plate);
      //           view.loadingHide();
      //         }, 1000);
      //       }
      //     },
      //     error: function (error) {
      //       console.log(error);
      //     },
      //   });
      // }, 5000);
    }
  }

  $("button")
    .off("click")
    .on("click", (e) => {
      e.preventDefault();

      let data = {
        lot: "P513",
        plate: strReplace($("#carplate").val().toUpperCase()),
        name: $("#userName").val(),
        phone: $("#userPhone").val(),
        rmk: $("#Place").val(),
      };

      if (data.plate === "") {
        $("#carplate").addClass("is-invalid");
        return;
      }

      if (data.phone === "") {
        $("#userPhone").addClass("is-invalid");
        return;
      }

      if (data.rmk === "") {
        $("#Place").addClass("is-invalid");
        return;
      }

      $.ajax({
        type: "POST",
        url: `../api/guestForm.php?${new Date().getTime()}&t=write`,
        data: {
          d: encryptByDES(JSON.stringify(data)),
        },
        dataType: "json",
        headers: httpHeader(),
        beforeSend: function () {
          $("input").removeClass("is-invalid");
          $("#reg").attr({ disabled: "disabled" });
          $("#reg").html(`
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Loading...</span>
                `);
        },
        complete: function () {
          $("#reg").removeAttr("disabled");
          $("#reg").text("確認");
        },
        success: function (json) {
          let status = json.result;
          if (status) {
            $("input[type=reset]").trigger("click"); //觸發reset按鈕

            let msg = `
                    <div class="container-fluid">
                        ${data.rmk !== "其他"
                ? `
                        <div class="d-flex justify-content-between align-items-center py-2">
                            <div class="fs-6">參訪地點位置如下：</div>
                            <div class="alert alert-warning m-0 px-2 py-0" style="font-size: 16px;">
                                <div class="d-flex gap-1">
                                    <div class="d-flex align-items-center text-warning">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-triangle-fill" viewBox="0 0 16 16">
                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2"></path>
                                        </svg>
                                    </div>
                                    <div>速限 30 公里，請減速慢行。</div>
                                </div>
                            </div>
                        </div>
                        ${map(data.rmk)}
                        `
                : `
                        <p class="fs-4">感謝填寫，祝您參訪愉快。</p>
                        `
              } 
                    </div>
                    `;

            view.messageShow(`訪客 ${data.plate}`, msg);
          }
        },
        error: function (error) {
          console.log(error);
          view.messageShow("錯誤", JSON.stringify(error));
        },
      });
    });
});

const map = (value) => {
  let map = "";
  if (value === "行政大樓") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1193.042112237743!2d120.28341235671152!3d22.733999099095914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f11b11ebd87%3A0x6a93b4c3e14eba8b!2zODEx6auY6ZuE5biC5qWg5qKT5Y2A6auY6ZuE5aSn5a246LevNzAw6Jmf6KGM5pS_5aSn5qiT!5e0!3m2!1szh-TW!2stw!4v1669023809643!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "圖書資訊館") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8372045446336!2d120.2852072!3d22.734291499999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f6a5d07df99%3A0x90b4ccfc8f31ea7e!2z5ZyL56uL6auY6ZuE5aSn5a245ZyW5pu46LOH6KiK6aSo!5e0!3m2!1szh-TW!2stw!4v1666681445064!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "工學院") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.888928473822!2d120.2765041!3d22.732369399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f15c40ca8b1%3A0xc887a526a03bbb91!2z5bel5a246Zmi!5e0!3m2!1szh-TW!2stw!4v1666681513063!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "理學院") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.7962551790733!2d120.28593029999998!3d22.735813099999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f0fdfed7d25%3A0xcdc1fdbbc0b6125!2z55CG5a246Zmi!5e0!3m2!1szh-TW!2stw!4v1666681574607!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "人文社會科學院") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.7987177044033!2d120.28139589999999!3d22.7357216!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f10de5eb52d%3A0x2ca6f9f624c1249a!2z5Lq65paH56S-5pyD56eR5a246Zmi!5e0!3m2!1szh-TW!2stw!4v1666681649469!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "法學院") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.876125027502!2d120.287136!3d22.7328452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f0e429691a5%3A0xa8fdb0243256b777!2z5ZyL56uL6auY6ZuE5aSn5a245rOV5a246Zmi!5e0!3m2!1szh-TW!2stw!4v1666681689838!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "管理學院") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8760873541037!2d120.28791189999998!3d22.7328466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f0e428e298f%3A0xe092a59b86a28bcd!2z566h55CG5a246Zmi!5e0!3m2!1szh-TW!2stw!4v1666681767689!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "游泳池") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.832382041244!2d120.27815740000001!3d22.7344707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0fdbf4c06cc1%3A0x3a98726ac84f001a!2z5ZyL56uL6auY6ZuE5aSn5a245ri45rOz5rGg!5e0!3m2!1szh-TW!2stw!4v1666681819844!5m2!1szh-TW!2stw" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "學生第一宿舍") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1547.1689368498296!2d120.27772983306347!3d22.735353819624358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f16e64cfb91%3A0xade9bf7eb02a1dd7!2z5a2455Sf56ys5LiA5a6_6IiN!5e0!3m2!1szh-TW!2stw!4v1732242214706!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "學生活動中心") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8895506271692!2d120.27859997530527!3d22.732346279378294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f3a56684c8d%3A0xa69cf3227ecbc7b3!2z6auY6ZuE5aSn5a245a2455Sf5rS75YuV5Lit5b-D!5e0!3m2!1szh-TW!2stw!4v1714110661632!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "綜合第一大樓") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d325.26177147641425!2d120.27725231852854!3d22.731331069315335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f15acacb6b5%3A0x88e9551b32253fed!2zODEx6auY6ZuE5biC5qWg5qKT5Y2A5aSn5a246KW_6LevNjUx6Jmf57ac5ZCI56ys5LiA5aSn5qiT!5e0!3m2!1szh-TW!2stw!4v1732242324910!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "棒球場") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8999993113557!2d120.27625007530521!3d22.731957979378592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14075c09e6090481%3A0xc992b10464c16761!2z5ZyL56uL6auY6ZuE5aSn5a24LeajkueQg-WgtA!5e0!3m2!1szh-TW!2stw!4v1741053595533!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "足球場") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8022775477834!2d120.28393754349011!3d22.73558932636072!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f00668c11c3%3A0xa8c2c6b01be4d97d!2z6auY6ZuE5aSn5a246Laz55CD5aC0!5e0!3m2!1szh-TW!2stw!4v1741053804685!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  } else if (value === "田徑場") {
    map = `
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.8006789346628!2d120.27507644349025!3d22.735648726360555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e0f4f6fc9a32b%3A0x1d9a874236afc409!2z55Sw5b6R5aC0!5e0!3m2!1szh-TW!2stw!4v1741053863534!5m2!1szh-TW!2stw" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        `;
  }

  return map;
};
